export const BannerType = {
  horizontal: "0",
  popup: "1"
}
